export default __webpack_public_path__ + "images/im-b21ce587e66db16e0428f4f3de36c4d3.svg";